import React from 'react';
import { useModal } from '../contexts';
import Modal from './Modal';

interface Props {
  onSave: (e: React.MouseEvent) => void;
  onDontSave: (e: React.MouseEvent) => void;
}

function WorkflowBlockModalSave(props: Props) {
  const { closeModal } = useModal();

  function handleSave(e: React.MouseEvent) {
    props.onSave(e);
    closeModal();
  }

  function handleDontSave(e: React.MouseEvent) {
    props.onDontSave(e);
    closeModal();
  }

  return (
    <Modal>
      <div className="flex flex-col">
        <div className="font-gilroy font-bold text-xl">Unsaved Changes</div>
        <div className="text-gray-500 text-sm">Would you like to save the changes you've made before exiting?</div>
        <div className="flex justify-between mt-10">
          <button className="btn btn-red" onClick={handleDontSave}>Don't Save</button>
          <button className="btn btn-blue" onClick={handleSave}>Save</button>
        </div>
      </div>
    </Modal>
  );
}

export default WorkflowBlockModalSave;
